import * as url from "helper/UrlHelper"; // Import the URL helper module

//function common header links
const groupDetailsHeaderLinks = (id, t) => {
  return [
    { title: t("Group Info"), link: `/admin/group/info/${id}` },
    { title: t("Members"), link: `/admin/group/members/${id}` },
    { title: t("Partners"), link: `/admin/group/grouppartner/${id}` },
    { title: t("Gallery"), link: `/admin/group/gallery/${id}` },
    // { title: "Feedback", link: `/admin/events/feedback/${id}` },
  ];
};

const createGroupChatHandler = async (groupId = null) => {
  try {
    const externalUrl = `${url.FRONTEND_BASE_URL}/conversation/group/${groupId}`;

    window.open(externalUrl, "_blank", "noopener,noreferrer");
  } catch (error) {
    console.error("Error occurred:", error.message); // Red alerts for errors
  }
};

export { groupDetailsHeaderLinks, createGroupChatHandler };
